import React, { useState } from "react";

import { Button, Row, Col } from "react-bootstrap";
import CreateModal from "../CreatePolicy/CreateModal";

export default function CreatePolicy() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="ibox-content mt20">
      <h1>Policy</h1>
      <Row>
        <Col md={9}>
          <p className="mt5">
            Create a Talent Insurance Policy for this enterprise. Each
            enterprise has a unique policy number assigned by LeggUP. Let's
            start!
          </p>
        </Col>
        <Col md={3} className="text-right">
          <Button
            onClick={() => setShowModal(true)}
            bsClass="btn btn-green width-120"
          >
            Create Policy
          </Button>
        </Col>
      </Row>

      <CreateModal show={showModal} onHide={() => setShowModal(false)} />
    </div>
  );
}
